import { ChakraFlex, FAIconName, FireflyButton } from '@equip.health/ui';

const TOPLEVEL_ID = 'treatment-episode-accordion-footer';

export interface FooterContentProps {
  leftEnabled: boolean;

  isReadOnly: boolean;
  onVoid: () => void;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
  rightEnabled: boolean;
}

const FooterContent = ({
  leftEnabled,
  isReadOnly,
  onEdit,
  onVoid,
  onSave,
  onCancel,
  rightEnabled,
}: FooterContentProps) => {
  const leftButtonLabel = isReadOnly ? 'Void' : 'Cancel';
  const leftButtonProps = isReadOnly
    ? {
        id: `${TOPLEVEL_ID}__void`,
        leftIcon: FAIconName.fileSlashRegular,
        onClick: onVoid,
      }
    : {
        id: `${TOPLEVEL_ID}__cancel`,
        leftIcon: FAIconName.timesRegular,
        onClick: onCancel,
      };

  const rightButtonLabel = isReadOnly ? 'Edit' : 'Save changes';
  const rightButtonProps = isReadOnly
    ? {
        id: `${TOPLEVEL_ID}__edit`,
        leftIcon: FAIconName.penRegular,
        onClick: onEdit,
      }
    : {
        id: `${TOPLEVEL_ID}__save`,
        leftIcon: FAIconName.checkRegular,
        onClick: onSave,
      };

  return (
    <ChakraFlex alignItems="center" justifyContent="space-between" width="100%">
      <FireflyButton
        {...leftButtonProps}
        isDisabled={!leftEnabled}
        variant="secondary"
      >
        {leftButtonLabel}
      </FireflyButton>
      <FireflyButton {...rightButtonProps} isDisabled={!rightEnabled}>
        {rightButtonLabel}
      </FireflyButton>
    </ChakraFlex>
  );
};

export default FooterContent;
